import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=1b15fbe7&"
import script from "./SortIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SortIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports